// @flow
import styled, { withTheme } from "styled-components";
import { Chevron } from "@nested/ui/icons";
import { media } from "../../media";

const ArrowCircle = styled.div`
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  padding: 10px;
  background-color: ${({ theme }) => theme.palette.sand100};
  border-radius: 50%;
  svg {
    transform: rotate(270deg);
  }
`;

const ArrowButton = () => (
  <ArrowCircle>
    <Chevron inverted={false} />
  </ArrowCircle>
);

const Wrapper = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 1200px;
  display: none;
  /* This is necessary for safari  */
  z-index: 1;

  ${media.desktop`
    display: block;
  `};
`;

const NextButton = styled.button`
  pointer-events: all;
  background-color: transparent;
  cursor: pointer;
  &:before {
    content: "";
  }
  position: absolute;
  right: 50px;
  display: block;
  top: calc(50% - 20px);
  outline: none;
  border: none;
  z-index: 1;
  svg {
    width: 100%;
    height: 100%;
  }
  ${media.tablet`
    right: 10px;
  `};
`;

const PrevButton = styled(NextButton)`
  right: unset;
  left: 50px;
  transform: rotateY(180deg);
  ${media.tablet`
    right: unset;
    left: 10px;
  `};
`;

export const NextArrow = withTheme(({ onClick }) => (
  <Wrapper>
    <NextButton onClick={onClick}>
      <ArrowButton />
    </NextButton>
  </Wrapper>
));

export const PrevArrow = withTheme(({ onClick }) => (
  <Wrapper>
    <PrevButton onClick={onClick}>
      <ArrowButton />
    </PrevButton>
  </Wrapper>
));
